import styled from "styled-components";
import { styles } from "../../GlobalStyle";

export const StyledAdditionalOrderDataWrapper = styled.div``;

export const StyledDataRow = styled.div`
  padding-top: ${styles.spacing.verySmall}px;
`;
